<template>
	<div>
        <div class="go-home" @click="goHome">
            <img src="https://oss.tuoxingwang.com/vaporetto-assets/common/go-home.png" alt="img"/>
        </div>
         <div class="go-order-list" @click="goOrderList">
            <img src="https://oss.tuoxingwang.com/vaporetto-assets/common/go-order-list.png" alt="img"/>
        </div>
    </div>
</template>
<style lang="scss" scoped>
.go-home,
.go-order-list {
	position: fixed;
	right: 0.48rem;
    z-index: 999;
	img {
		width: 1.44rem;
		height: 1.44rem;
	}
}
.go-home {
    bottom: 5.2rem;
}
.go-order-list {
    bottom: 3.2rem;
}
</style>
<script>
export default {
    name: "PageGuide",
    data(){
        return{}
    },
    methods:{
        goHome(){
            this.$router.push("/scene");
        },
        goOrderList(){
            this.$router.push("/userOrderList");
        }
    }
};
</script>

